import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["mainImage", "thumbnail"]

  static values = {
    activeIndex: Number,
    images: Array
  }

  connect() {
    this.currentIndex = this.hasActiveIndexValue ? this.activeIndexValue : 0
    this.render()
  }

  select(event) {
    const nextIndex = Number(event.params.index)
    if (Number.isNaN(nextIndex)) return

    this.currentIndex = nextIndex
    this.render()
  }

  render() {
    const images = this.imagesValue || []
    const image = images[this.currentIndex] || images[0]
    if (!image || !this.hasMainImageTarget) return

    this.currentIndex = Math.max(0, Math.min(this.currentIndex, images.length - 1))

    this.mainImageTarget.src = image.full_path
    this.mainImageTarget.alt = image.alt || ""

    this.thumbnailTargets.forEach((thumbnail, index) => {
      const active = index === this.currentIndex
      thumbnail.classList.toggle("active", active)
      thumbnail.setAttribute("aria-pressed", active ? "true" : "false")
    })
  }
}
